export const getPropositionContent = (noRecipes: number) => ({
  title: 'Key things about our menu',
  content: [
    {
      icon: 'offer_pound',
      text: [{ bold: 'Add more recipes for the best price per portion' }],
    },
    {
      icon: 'meals_per_box',
      text: [{ normal: 'Over 75 recipes' }, { bold: 'changing weekly' }],
    },
    {
      icon: 'skip',
      text: [{ bold: `Choose 2 to ${noRecipes} recipes` }],
    },
    {
      icon: 'dietary_preference',
      text: [{ normal: 'Meals for every appetite and dietary need' }],
    },
  ],
})
